import { Image, Skeleton, Space } from "antd-mobile";
import { CicleCellDataType } from "./data";
import { SkeletorImg } from "components/dot/skeloton";
import { useI18n } from "i18n/useI18n";

export default function CicleCell(
  props: { onClick: () => void } & CicleCellDataType
) {
  const { t } = useI18n();
  return (
    <>
      <Space
        align="center"
        justify="center"
        direction="vertical"
        style={{
          margin: 5,
        }}
        onClick={() => {
          props?.onClick();
        }}
      >
        <Image
          style={{
            borderRadius: 999,
            aspectRatio: 1 / 1,
            ...props.style,
          }}
          width="100%"
          fit="cover"
          height={60}
          src={props.cover}
          fallback={<SkeletorImg height={60} />}
          placeholder={<SkeletorImg height={60} />}
        />
        <p style={{ fontSize: "0.8rem", margin: "5px 0px 0px 0px" }}>
          {props.title}
        </p>
      </Space>
    </>
  );
}
